import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/AdminSettings.css";

function AdminSettings() {
  const navigate = useNavigate();

  return (
    <div className="main-layout">

      <div className="sidebar">
        <h2 className="logo">🏠 RealEstate</h2>

        <ul>
          <li onClick={() => navigate("/admin/dashboard")}>Dashboard</li>
          <li onClick={() => navigate("/admin/properties")}>Properties</li>
          <li onClick={() => navigate("/admin/buys")}>Buys</li>
          <li onClick={() => navigate("/admin/sales")}>Sales</li>
          <li onClick={() => navigate("/admin/rents")}>Rents</li>
          <li onClick={() => navigate("/admin/messages")}>Messages</li>
          <li className="active">Settings</li>
        </ul>
      </div>

      <div className="dashboard-container">
        <div className="topbar">⚙️ Settings</div>

        <h2>Settings Page</h2>
      </div>

    </div>
  );
}

export default AdminSettings;